import { apiRequest } from "./apiClient";

export function revealBankAccountCredentials(id) {
  return apiRequest(`/api/bank-accounts/${id}/credentials/reveal`, { method: "POST" });
}

function pageQuery({ page = 0, size = 20, query = "", active, categoryId = "", accountType = "", bankName = "" } = {}) {
  const params = new URLSearchParams();
  params.set("page", Math.max(0, Number(page) || 0));
  params.set("size", Math.min(100, Math.max(1, Number(size) || 20)));
  if (query.trim()) params.set("query", query.trim());
  if (active !== undefined && active !== null && active !== "") params.set("active", active);
  if (categoryId) params.set("categoryId", categoryId);
  if (accountType) params.set("accountType", accountType);
  if (bankName) params.set("bankName", bankName);
  return params.toString();
}

export function listBankAccounts(options) {
  return apiRequest(`/api/bank-accounts?${pageQuery(options)}`);
}

export function listBankNames() { return apiRequest("/api/bank-accounts/banks"); }

export async function listAllActiveBankAccounts() {
  const content = [];
  let page = 0;
  let result;
  do {
    result = await listBankAccounts({ page, size: 100, active: true });
    content.push(...(result.content || []));
    page += 1;
  } while (result.last === false);
  return content;
}

export function getBankAccount(id) {
  return apiRequest(`/api/bank-accounts/${id}`);
}

export function createBankAccount(values) {
  return apiRequest("/api/bank-accounts", { method: "POST", body: JSON.stringify(values) });
}

export function updateBankAccount(id, values) {
  return apiRequest(`/api/bank-accounts/${id}`, { method: "PUT", body: JSON.stringify(values) });
}

export function deactivateBankAccount(id, reason) {
  const query = reason ? `?reason=${encodeURIComponent(reason)}` : "";
  return apiRequest(`/api/bank-accounts/${id}${query}`, { method: "DELETE" });
}

export function activateBankAccount(id, reason) {
  const query = reason ? `?reason=${encodeURIComponent(reason)}` : "";
  return apiRequest(`/api/bank-accounts/${id}/activate${query}`, { method: "PUT" });
}

export function getUserAssignments(userId) {
  return apiRequest(`/api/users/${userId}/accounts`);
}

export function replaceUserAssignments(userId, accountIds) {
  return apiRequest(`/api/users/${userId}/accounts`, {
    method: "PUT",
    body: JSON.stringify({ accountIds: [...new Set(accountIds)] }),
  });
}
